import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let autoRouters = []
let pages = require.context('./routes', false, /\.routes\.js/)
pages.keys().forEach(key => {
    if (pages(key).default) autoRouters.push(pages(key).default)
})
autoRouters.sort(function (a, b) {
    let as = a.sort || 0
    let bs = b.sort || 0
    return bs - as
})

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        component: () => import('@/views/Personal/changePassword'),
        meta: {
            title: '修改密码'
        }
    },
    {
        path: '/andonOrderJump',
        name: 'andonOrderJump',
        component: () => import('@/views/permission/andonJump/andonOrderList.vue'),
        meta: {
            title: '安灯工单'
        }
    },
	{
	    path: '/acoustoSpectaculars2',
	    name: 'acoustoSpectaculars',
	    component: () => import('@/views/permission/spectaculars/acoustoSpectaculars.vue'),
	    meta: {
	        title: '报警看板',
	    }
	},
    {
        path: '/andonOrderDetailJump',
        name: 'andonOrderDetailJump',
        component: () => import('@/views/permission/andonJump/andonOrderDetail.vue'),
        meta: {
            title: '安灯工单'
        }
    },
    {
        path: '/',
        name: 'layout',
        component: () => import('@/views/layout'),
        redirect: {
            name: 'Home'
        },
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/views/home/home'),
                meta: {
                    title: 'demo.menu.HomePage'
                }
            }
        ]
    },
    {
        path: '/personal_layout',
        name: 'PersonalLayout',
        component: () => import('@/views/layout'),
        redirect: {
            name: 'Personal'
        },
        children: [
            /*{
                path: '/personal',
                name: 'Personal',
                component: () => import('@/views/Personal/personal'),
                meta: {
                    title: '个人中心'
                }
            }*/
        ]
    },

    ...autoRouters,
    {
        path: '/404',
        component: () => import('@/views/errorPage/404'),
        meta: {
            title: '找不到访问路径'
        },
        name: 'NotFind'
    },
    {
        path: '/401',
        component: () => import('@/views/errorPage/401'),
        meta: {
            title: '用户没有权限访问'
        },
        name: 'NotAuthorized'
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    },
	
    /*{
        path: '/acoustoSpectaculars',
        name: 'acoustoSpectaculars',
        component: () => import('@/views/permission/spectaculars/acoustoSpectaculars.vue'),
        meta: {
            title: '可视化声光预警看板',
        },
        name: 'acoustoSpectaculars'
    },
    {
        path: '/manuSpectaculars',
        name: 'manuSpectaculars',
        component: () => import('@/views/permission/spectaculars/manuSpectaculars.vue'),
        meta: {
            title: '智能生产看板',
        }
    },*/
]
/**
 *路由对象初始化
 **/
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = '均胜智能制造系统管理平台'
    next()
})

export default router
